(function (w) {
  const requiredElementSelector = '.calculate';
  const requiredElement = document.querySelector(requiredElementSelector);

  if (!requiredElement) {
    return;
  }


  if (!Object.prototype.forEach) {
    Object.defineProperty(Object.prototype, 'forEach', {
      value: function (callback, thisArg) {
        if (this === null) throw new TypeError('Not an object');
        thisArg = thisArg || window;
        for (let key in this) {
          if (Object.prototype.hasOwnProperty.call(this, key)) {
            if (typeof callback === 'function') {
              if (callback.call(thisArg, this[key], key, this) === false) break;
            }
          }
        }
      }
    });
  }

  function Base(options) {
    this.state = this.state || {};
    this.elements = this.elements || {};
    this.events = this.events || {};

    this
        .setOptions(options)
        .collectElements()
        .updateOptions()
        .subscribeEvents();
  }

  Base.prototype.setOptions = function (options) {
    if (!this.options && this.defaultOptions) {
      this.options = {};
      for (const key in this.defaultOptions) {
        this.options[key] = this.defaultOptions[key];
      }
      Object.assign(this.options, options || {});
    }
    return this;
  };

  Base.prototype.updateOptions = function () {
    if (this.elements.mainEl) {
      const dataset = this.elements.mainEl.dataset;
      for (const key in dataset) {
        if (Object.hasOwn(dataset, key)) {
          this.options[key] = dataset[key];
        }
      }
    }
    return this;
  };

  Base.prototype.collectElements = function () {
    const self = this;

    if (
        this.options &&
        this.options.elements &&
        this.options.elements.main
    ) {
      if (!this.elements.mainEl) {
        if (this.options.elements.main instanceof HTMLElement) {
          this.elements.mainEl = this.options.elements.main;
        } else {
          this.elements.mainEl = document.querySelector(this.options.elements.main);
        }
      }

      if (this.elements.mainEl) {
        Object.entries(this.options.elements).forEach(([key, val]) => {
          if (key !== 'main' && val && !this.elements[key + 'El']) {
            let el;
            if (key === 'fields' || key === 'dynamic') {
              // Для fields используем querySelectorAll
              el = this.elements.mainEl.querySelectorAll(val);
            } else if (val.startsWith('#')) {
              el = document.querySelector(val);
            } else {
              el = this.elements.mainEl.querySelector(val);
            }
            if (el) {
              this.elements[key + 'El'] = el;
            }
          }
        });
      }
    }
    return this;
  };

  Base.prototype.subscribe = function (event, callback) {
    const [mainEvent, subEvent] = event.split('.');
    if (!this.events[mainEvent]) {
      this.events[mainEvent] = { all: [] };
    }
    if (subEvent) {
      this.events[mainEvent][subEvent] = this.events[mainEvent][subEvent] || [];
      this.events[mainEvent][subEvent].push(callback);
    } else {
      this.events[mainEvent].all.push(callback);
    }
    return this;
  };

  Base.prototype.unsubscribe = function (event) {
    const [mainEvent, subEvent] = event.split('.');
    if (this.events[mainEvent]) {
      if (subEvent) {
        this.events[mainEvent][subEvent] = [];
      } else {
        this.events[mainEvent].all = [];
      }
    }
    return this;
  };

  Base.prototype.callEvent = function (event, data) {
    let isDo = true;
    const self = this;
    if (this.events[event]) {
      Object.values(this.events[event]).forEach((handlers) => {
        if (Array.isArray(handlers)) {
          for (const fn of handlers) {
            if (typeof fn === 'function') {
              const result = fn.call(self, data);
              if (result !== undefined && result !== true) {
                isDo = false;
              }
            }
            if (!isDo) break;
          }
        }
      });
    }
    return this;
  };

  Base.prototype.subscribeEvents = function () {
    const self = this;
    if (this.options.events) {
      this.options.events.forEach(function (fn, key) {
        if (typeof fn === 'function' && typeof key === 'string') {
          self.subscribe(key, fn);
        }
      });
    }
    return this;
  };

  Base.prototype.animateHeight = function (el, action, callback) {
    const self = this;
    if (!el) return this;
    if (!callback) callback = () => {};
    const transitionEnd = 'transitionend';

    const onTransitionEnd = function () {
      el.removeEventListener(transitionEnd, onTransitionEnd);
      callback.call(self, el);
    };

    if (action === 'show') {
      if (el.classList.contains('hide')) {
        el.classList.remove('hide');
        el.style.height = el.scrollHeight + 'px';
        el.addEventListener(transitionEnd, () => {
          el.style.height = 'auto';
          callback.call(self, el);
        });
      }
    } else if (action === 'hide') {
      if (!el.classList.contains('hide')) {
        el.style.height = el.offsetHeight + 'px';
        el.classList.add('hide');
        el.addEventListener(transitionEnd, onTransitionEnd);
        setTimeout(() => {
          el.style.height = '0';
        }, 10);
      }
    } else if (typeof action === 'number') {
      el.style.height = el.offsetHeight + 'px';
      el.classList.add('hide');
      el.addEventListener(transitionEnd, onTransitionEnd);
      setTimeout(() => {
        el.style.height = action + 'px';
      }, 10);
    }

    return this;
  };

  Base.generateId = Base.prototype.generateId = function () {
    return new Date().getUTCMilliseconds() + Math.random().toString(36).substring(2, 11);
  };

  Base.prototype.sortArrayWithObjects = function (arr, key, direct) {
    if (!Array.isArray(arr) || !arr.length || !key) return arr;

    const quickSort = (a, l = 0, r = a.length - 1) => {
      if (l >= r) return;

      const pivot = a[Math.floor((l + r) / 2)][key];
      let i = l;
      let j = r;

      while (i <= j) {
        while (a[i][key] < pivot) i++;
        while (a[j][key] > pivot) j--;
        if (i <= j) {
          [a[i], a[j]] = [a[j], a[i]];
          i++;
          j--;
        }
      }

      if (l < j) quickSort(a, l, j);
      if (i < r) quickSort(a, i, r);
      return a;
    };

    arr = quickSort([...arr]);
    if (direct === 'up') arr.reverse();

    return arr;
  };

  w.uteka = w.uteka || {};
  w.uteka.Base = Base;

})(window);
